import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { DataUrl, NgxImageCaptureModule, NgxImageCompressService, UploadResponse } from 'ngx-image-compress';
import { CustomButtonComponent } from '../custom-button/custom-button.component';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

type ButtonSeverity = 'success' | 'primary' | 'secondary' | 'info' | 'warn' | 'danger' | 'help' | 'contrast' | null | undefined;
type ButtonVariant = 'outlined' | 'text' | undefined;

@Component({
  selector: 'app-custom-input-image-file',
  templateUrl: './custom-input-image-file.component.html',
  styleUrls: ['./custom-input-image-file.component.scss'],
  standalone: true,
  imports: [CustomButtonComponent, CommonModule, NgxImageCaptureModule],
  providers: [NgxImageCompressService],
})
export class CustomInputImageFileComponent implements OnInit {

  @Input() maxWidth: number = 400;
  @Input() maxHeight: number = 400;
  @Input() label: string = "";
  @Input() icon: string = "";
  @Input() idFileName: string = "";
  @Input() disabled: boolean = false;
  @Input() width?: string;
  @Input() severity: ButtonSeverity = "primary";
  @Input() variant: ButtonVariant = "outlined";
  @Output() imgResultAfterResize = new EventEmitter<File>();
  @Output() imgUrl = new EventEmitter<string>();

  constructor(private imageCompress: NgxImageCompressService,
    private toastHandlerService: ToastHandlerService) { }

  ngOnInit() {
  }

  uploadAndResize() {
    return this.imageCompress
      .uploadFile()
      .then(({ image, orientation, fileName }: UploadResponse) => {
        this.imageCompress
          .compressFile(image, orientation, 50, 50, this.maxWidth, this.maxHeight)
          .then((result: DataUrl) => {
            this.imgUrl.emit(result);

            const byteString = atob(result.split(',')[1]);
            const mimeString = result
              .split(',')[0]
              .split(':')[1]
              .split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            const newFileName = this.renameFileWithDate(fileName);
            const file = new File([blob], newFileName, {
              type: mimeString,
              lastModified: new Date().getTime(),
            });

            this.imgResultAfterResize.emit(file);
          });
      }).catch(error => {
        this.toastHandlerService.showToast('error', 'Error al subir la imagen.', '');
        console.error("Ocurrió un error al subir o comprimir la imagen:", error);
      });
  }

  renameFileWithDate(nameFile: string): string {
    const timestamp = Date.now();
    const point = nameFile.lastIndexOf('.');
    const extension = point !== -1 ? nameFile.substring(point + 1) : '';

    const newName = extension
      ? `${this.idFileName}_${timestamp}.${extension}`
      : `${this.idFileName}_${timestamp}`;

    return newName;
  }

}
